/**
 * Search Page
 * Dedicated page for knowledge base search functionality
 */
import React, { useState } from 'react';
import { SearchBar } from '../components/search/SearchBar';
import { UserMenu } from '../components/UserMenu';
import { KnowledgeGapButton } from '../components/KnowledgeGapButton';
import { MainNavigation } from '../components/MainNavigation';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

export function SearchPage() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="glass border-b border-white/10 px-4 py-3">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <h1 className="text-xl font-bold gradient-text">XORA</h1>
            <MainNavigation className="hidden md:flex" />
          </div>
          
          <div className="flex items-center space-x-4">
            <KnowledgeGapButton />
            <UserMenu />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="w-full max-w-4xl"
        >
          <div className="text-center mb-8">
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.1 }}
              className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 mb-4"
            >
              <Sparkles className="w-8 h-8 text-white" />
            </motion.div>
            <h2 className="text-3xl font-bold mb-2">
              Was möchten Sie wissen?
            </h2>
            <p className="text-gray-400">
              Durchsuchen Sie unsere Wissensdatenbank
            </p>
          </div>
          <SearchBar 
            value={searchQuery}
            onChange={setSearchQuery}
            autoFocus
          />
        </motion.div>
      </main>
    </div>
  );
}